import { call, put } from "redux-saga/effects";
import { apiRouting, notify } from "services";
import { IUpdateRequest } from "interfaces/update-duck";
import { requestErrorHandler } from "utils";
import { UpdatePickingQuarentineActions } from "store/ducks/picking-quarentines";

export function* updatePickingQuarentineRequest(action: any) {
  try {
    const { id, putData, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(
      apiRouting.put,
      `/picking-quarentines/${id}`,
      putData
    );

    const { data } = responseBody;
    yield put(UpdatePickingQuarentineActions.success(data));
    notify("success", "Carga atualizada com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(UpdatePickingQuarentineActions.failure(errorMessage));
  }
}
